// Sider + Header + Content shell for authenticated pages.

import { useState } from 'react';
import { Layout, Menu, Button, Typography, Avatar, Dropdown, Space } from 'antd';
import {
  DashboardOutlined,
  TeamOutlined,
  KeyOutlined,
  LogoutOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config/routes';
import { useAuth } from '../../features/auth/useAuth';

const { Sider, Header, Content } = Layout;
const { Text } = Typography;

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const items = [
    { key: ROUTES.dashboard, icon: <DashboardOutlined />, label: 'Dashboard' },
    { key: ROUTES.customers, icon: <TeamOutlined />, label: 'Customers' },
    { key: ROUTES.licenses, icon: <KeyOutlined />, label: 'Licenses' },
    // User management is admin-only — hidden entirely for managers.
    ...(user?.role === 'admin'
      ? [{ key: ROUTES.users, icon: <UsergroupAddOutlined />, label: 'Quản lý user' }]
      : []),
    { key: ROUTES.help, icon: <QuestionCircleOutlined />, label: 'Hướng dẫn' },
  ];

  // Highlight the deepest matching menu item.
  const selectedKey = [...items]
    .reverse()
    .find((i) => location.pathname.startsWith(i.key) && (i.key !== '/' || location.pathname === '/'))?.key ?? ROUTES.dashboard;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        breakpoint="lg"
        onBreakpoint={(broken) => setCollapsed(broken)}
        theme="dark"
      >
        <div style={{ height: 56, display: 'grid', placeItems: 'center', color: '#fff', fontWeight: 700 }}>
          {collapsed ? 'L' : 'License Admin'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={items}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: 'Đăng xuất',
                  onClick: () => void logout(),
                },
              ],
            }}
          >
            <Space style={{ cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <Text>{user?.username ?? ''}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>({user?.role})</Text>
            </Space>
          </Dropdown>
        </Header>
        <Content style={{ padding: 24, overflow: 'auto' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
